//
import { List, Record } from 'immutable';

import { mkConfirmationDialogProps } from '../ConfirmationDialog/types';

export const mkRefreshTimeoutDialogProps = Record({
  dialogIdsToClose: List(),

  confirmationDialogProps: mkConfirmationDialogProps(),
});

export const DIALOG_TYPE = 'DIALOG_REFRESH_TIMEOUT';
